"use strict";

require("core-js/modules/es.promise");

var nop = require("../Strict/nop.js");

module.exports = go2;

function go2(acc, a, f) {
  return a instanceof Promise ? a.then(a => f(acc, a), e => e == nop ? acc : Promise.reject(e)) : f(acc, a);
}